export default "__VITE_ASSET__CmrHA99n__"